<template>
  <v-autocomplete
    :items="countries"
    item-text="label"
    item-value="code"
    label="Código do País"
    :value="value"
    @change="
      searching = false;
      $emit('input', $event);
    "
    @focus="searching = true"
    @blur="searching = false"
    :rules="rules"
    :menu-props="{ maxWidth: 304, minWidth: 304 }"
    hide-no-data
    required
    solo
    flat
    background-color="#F7F7F7"
  >
    <template v-slot:selection="{ item }">
      <span v-if="!searching">{{ item.dial }}</span>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  props: {
    value: { type: String, default: '' },
    rules: { type: Array, default: () => [] },
    countries: { type: Array, required: true },
  },
  data: () => ({ searching: false }),
};
</script>
